/**
 * api接口的统一出口
*/
import Login from '@/api/Login';
import userInfo from '@/api/userInfo'
import order from '@/api/order'
import merchant from '@/api/merchant'
export default {
    Login,
    userInfo,
    order,
    merchant
}


// WEBPACK FOOTER //
// ./src/api/index.js